import * as Tone from 'tone';
class AutomationManager {
    constructor() {
        this.parameters = {};
    }
    getTarget(object, parameter) {
        var _a, _b;
        return (_b = (_a = this.parameters) === null || _a === void 0 ? void 0 : _a[object]) === null || _b === void 0 ? void 0 : _b[parameter];
    }
    makeAutomatable(object, parameter, target) {
        if (target instanceof Tone.Param) {
            if (!this.parameters[object]) {
                this.parameters[object] = {};
            }
            this.parameters[object][parameter] = target;
        }
        else {
            throw Error('Target is not a Tone.Param');
        }
    }
}
export default AutomationManager;
//# sourceMappingURL=AutomationManager.js.map